module.exports = __webpack_public_path__ + "img/logo-icon.62e5a580.png";